module.exports = __webpack_public_path__ + "6c4cdf0b78f181cb8a73d8dcc67ba7b2.jpg";